import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import ROUTES from '../../data/routes';
import SidebarMenus from '../sidebar/SidebarMenus';

import { logout } from '../../app/store/actions/auth';

class HeaderLogo extends React.PureComponent {
  render() {
    const { opico } = this.props;
    return (
      <div className="navbar-header">
        <a href={ROUTES.HOME} className="navbar-brand">
          <span className="navbar-logo" />
          <b>{opico && opico.settings.name}</b>
          <b>{' '}</b>
          <Translate value="panel" />
        </a>

        <div className="btn-group icon-menu-right">
          <button
            type="button"
            className="btn-not-styled navbar-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-click="sidebar-toggled"
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
          <div className="dropdown-menu">
            <div className="menu-mobile">
              <SidebarMenus />
            </div>
          </div>
        </div>

        <div className="btn-group icon-menu-right icon-margin-width">
          <button
            type="button"
            className="btn-not-styled button-header-profile"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img className="img-header-profile" src="images/profile-logo.png" alt="Usuário" />
          </button>
          <div className="dropdown-menu">
            {/* <button className="dropdown-item cursor-pointer" type="button">Meu Perfil</button>
            <button className="dropdown-item cursor-pointer" type="button">Configurações</button>
            <button className="dropdown-item cursor-pointer" type="button">Alterar Senha</button>
            */}
            <button
              className="dropdown-item cursor-pointer"
              type="button"
              onClick={() => this.props.logout()}
            >
              <Translate value="exit" />
            </button>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  opico: state,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogo);
